/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BatchImportComponentClassesRequestDto,
  ComponentClassResponseDto,
  CreateComponentClassRequestDto,
  ListComponentClassesResponseDto,
  UpdateComponentClassRequestDto,
} from '../models/index';
import {
    BatchImportComponentClassesRequestDtoFromJSON,
    BatchImportComponentClassesRequestDtoToJSON,
    ComponentClassResponseDtoFromJSON,
    ComponentClassResponseDtoToJSON,
    CreateComponentClassRequestDtoFromJSON,
    CreateComponentClassRequestDtoToJSON,
    ListComponentClassesResponseDtoFromJSON,
    ListComponentClassesResponseDtoToJSON,
    UpdateComponentClassRequestDtoFromJSON,
    UpdateComponentClassRequestDtoToJSON,
} from '../models/index';

export interface ComponentClassControllerBatchImportRequest {
    batchImportComponentClassesRequestDto: BatchImportComponentClassesRequestDto;
}

export interface ComponentClassControllerCreateRequest {
    createComponentClassRequestDto: CreateComponentClassRequestDto;
}

export interface ComponentClassControllerDeleteRequest {
    id: string;
}

export interface ComponentClassControllerFindAllRequest {
    limit: number;
    page: number;
    includeSubsystemIds?: boolean;
    mappingId?: string;
    tableFilterFieldValue?: string;
    tableFilterFieldName?: string;
    mappingKey?: ComponentClassControllerFindAllMappingKeyEnum;
    operator?: ComponentClassControllerFindAllOperatorEnum;
    q?: string;
}

export interface ComponentClassControllerFindByIdRequest {
    id: string;
}

export interface ComponentClassControllerUpdateRequest {
    id: string;
    updateComponentClassRequestDto: UpdateComponentClassRequestDto;
}

/**
 * 
 */
export class KnowledgeBaseComponentClassesApi extends runtime.BaseAPI {

    /**
     */
    async componentClassControllerBatchImportRaw(requestParameters: ComponentClassControllerBatchImportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['batchImportComponentClassesRequestDto'] == null) {
            throw new runtime.RequiredError(
                'batchImportComponentClassesRequestDto',
                'Required parameter "batchImportComponentClassesRequestDto" was null or undefined when calling componentClassControllerBatchImport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/component-classes/batch-import`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BatchImportComponentClassesRequestDtoToJSON(requestParameters['batchImportComponentClassesRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async componentClassControllerBatchImport(requestParameters: ComponentClassControllerBatchImportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.componentClassControllerBatchImportRaw(requestParameters, initOverrides);
    }

    /**
     */
    async componentClassControllerCreateRaw(requestParameters: ComponentClassControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ComponentClassResponseDto>> {
        if (requestParameters['createComponentClassRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createComponentClassRequestDto',
                'Required parameter "createComponentClassRequestDto" was null or undefined when calling componentClassControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/component-classes`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateComponentClassRequestDtoToJSON(requestParameters['createComponentClassRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ComponentClassResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async componentClassControllerCreate(requestParameters: ComponentClassControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ComponentClassResponseDto> {
        const response = await this.componentClassControllerCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async componentClassControllerDeleteRaw(requestParameters: ComponentClassControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling componentClassControllerDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/component-classes/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async componentClassControllerDelete(requestParameters: ComponentClassControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.componentClassControllerDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async componentClassControllerFindAllRaw(requestParameters: ComponentClassControllerFindAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListComponentClassesResponseDto>> {
        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling componentClassControllerFindAll().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling componentClassControllerFindAll().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['includeSubsystemIds'] != null) {
            queryParameters['includeSubsystemIds'] = requestParameters['includeSubsystemIds'];
        }

        if (requestParameters['mappingId'] != null) {
            queryParameters['mappingId'] = requestParameters['mappingId'];
        }

        if (requestParameters['tableFilterFieldValue'] != null) {
            queryParameters['tableFilterFieldValue'] = requestParameters['tableFilterFieldValue'];
        }

        if (requestParameters['tableFilterFieldName'] != null) {
            queryParameters['tableFilterFieldName'] = requestParameters['tableFilterFieldName'];
        }

        if (requestParameters['mappingKey'] != null) {
            queryParameters['mappingKey'] = requestParameters['mappingKey'];
        }

        if (requestParameters['operator'] != null) {
            queryParameters['operator'] = requestParameters['operator'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/component-classes`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListComponentClassesResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async componentClassControllerFindAll(requestParameters: ComponentClassControllerFindAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListComponentClassesResponseDto> {
        const response = await this.componentClassControllerFindAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async componentClassControllerFindByIdRaw(requestParameters: ComponentClassControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ComponentClassResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling componentClassControllerFindById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/component-classes/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ComponentClassResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async componentClassControllerFindById(requestParameters: ComponentClassControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ComponentClassResponseDto> {
        const response = await this.componentClassControllerFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async componentClassControllerUpdateRaw(requestParameters: ComponentClassControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ComponentClassResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling componentClassControllerUpdate().'
            );
        }

        if (requestParameters['updateComponentClassRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateComponentClassRequestDto',
                'Required parameter "updateComponentClassRequestDto" was null or undefined when calling componentClassControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/component-classes/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateComponentClassRequestDtoToJSON(requestParameters['updateComponentClassRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ComponentClassResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async componentClassControllerUpdate(requestParameters: ComponentClassControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ComponentClassResponseDto> {
        const response = await this.componentClassControllerUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ComponentClassControllerFindAllMappingKeyEnum = {
    Atsscc: 'ATSSCC',
    Atssccsst: 'ATSSCCSST'
} as const;
export type ComponentClassControllerFindAllMappingKeyEnum = typeof ComponentClassControllerFindAllMappingKeyEnum[keyof typeof ComponentClassControllerFindAllMappingKeyEnum];
/**
 * @export
 */
export const ComponentClassControllerFindAllOperatorEnum = {
    Included: 'INCLUDED',
    NotIncluded: 'NOT_INCLUDED'
} as const;
export type ComponentClassControllerFindAllOperatorEnum = typeof ComponentClassControllerFindAllOperatorEnum[keyof typeof ComponentClassControllerFindAllOperatorEnum];
